import { LAW_FIRM_PRESET } from './law-firm';
import { CONSTRUCTION_PRESET } from './construction';

export { LAW_FIRM_PRESET, CONSTRUCTION_PRESET };
export const PRESETS = [LAW_FIRM_PRESET, CONSTRUCTION_PRESET];
